import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import { useEffect } from "react"
import { CommandPalette } from "@/components/shared/command-palette"
import { NotFound } from "@/components/shared/errors/not-found"
import { HeaderProvider, PageHeader } from "@/components/shared/layout"
import { Sidebar } from "@/components/shared/sidebar"
import {
	AuthLevel,
	forceSignOut,
	getAuthLevel,
	getSessionUser,
	isSessionStillValid,
	signOut,
} from "@/lib/auth"
import { REQUIRE_MFA } from "@/lib/constants"

export const Route = createFileRoute("/_authenticated")({
	beforeLoad: async ({ context }) => {
		if (!context.auth?.id) {
			const user = await getSessionUser()
			if (!user?.id) {
				await signOut()
				throw redirect({ to: "/login" })
			}

			if (REQUIRE_MFA) {
				const authLevel = await getAuthLevel()
				if (authLevel !== AuthLevel.FullyAuthenticated) {
					await signOut()
					throw redirect({ to: "/login" })
				}
			}

			return { auth: user }
		}
	},
	component: AuthenticatedLayout,
	notFoundComponent: NotFound,
})

function AuthenticatedLayout() {
	useEffect(() => {
		isSessionStillValid().then((valid) => {
			if (!valid) forceSignOut()
		})
	}, [])

	return (
		<HeaderProvider>
			<div className="flex min-h-screen bg-background">
				<Sidebar />
				<main className="flex-1 flex flex-col min-w-0">
					<div className="sticky top-0 z-30 bg-background">
						<PageHeader />
					</div>
					<Outlet />
				</main>
			</div>
			<CommandPalette />
		</HeaderProvider>
	)
}
